import React from 'react';
import { Box, Button, Modal, Text } from '@razorpay/blade/components';
import ActionModal from 'components/SalaryComponents/components/ActionModal';

type Props = Pick<React.ComponentProps<typeof Modal>, 'isOpen' | 'onDismiss'> & {
  isLoading?: boolean;
  componentName: string;
  description: string;
  descriptionOnAction: string;
  onSubmit: () => void;
};

const DeleteModal = ({
  componentName,
  descriptionOnAction,
  description,
  isOpen,
  onDismiss,
  onSubmit,
  isLoading,
}: Props) => {
  return (
    <ActionModal
      isOpen={isOpen}
      onDismiss={onDismiss}
      headingText={`Delete ${componentName} ?`}
      submitButton={
        <Button
          testID={`delete-component-button`}
          size={'medium'}
          onClick={onSubmit}
          color={'negative'}
          isLoading={isLoading}>
          {`Delete ${componentName ?? 'Now'}`}
        </Button>
      }>
      <Box display={'flex'} flexDirection={'column'} gap={'spacing.5'}>
        <Box display={'flex'} flexDirection={'column'} gap={'spacing.2'}>
          <Text color={'surface.text.gray.subtle'}>{description}</Text>
        </Box>
        <Box display={'flex'} flexDirection={'column'} gap={'spacing.2'}>
          <Text size="small" color={'surface.text.gray.muted'} weight={'medium'}>
            What will happen?
          </Text>
          <Text color={'surface.text.gray.subtle'}>{descriptionOnAction}</Text>
        </Box>
      </Box>
    </ActionModal>
  );
};

export default DeleteModal;
